export const IDENTITY_PROVIDER_HEADER = "x-identity-provider";
export const AUTH_CHANNEL_HEADER = "x-auth-channel";
export const CHANNEL_HEADER = "x-channel";
export const BROWSER_LOCALE_HEADER = "x-browser-locale";
export const ADBLOCK_DETECTED_HEADER = "x-adblock-detected";
export const USER_IDENTITY_HEADER = "Authorization";
export const APP_CONNECTION_ID_HEADER = "x-app-connection-id";
export const ATTESTATION_TOKEN_HEADER = "x-attestation-token";
export const API_KEY_HEADER = "x-api-key";
export const APP_ID_HEADER = "x-app-id";
export const APQ_PREFLIGHT_HEADER = "apollo-require-preflight";

export enum AuthChannelType {
  otp = "otp",
  oauth = "oauth",
}

export enum MembershipProviderType {
  Stripe = "stripe",
}
